import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import {Unsubscribe} from "../unsubscribe/Unsubscribe";

/**
 * Public route wrapper for `/unsubscribe` (ui#316).
 *
 * Pre-rendered as a SHELL only: the opt-out token arrives in the query string, so the page has no
 * per-URL static content and needs no dynamic path segment — which is also why it does not need a
 * CloudFront SPA prefix entry, unlike `/activate/:token`. `noIndex` because the page is meaningless
 * without a signed token and must never surface in search results.
 */
export function Component() {
	const {unsubscribe} = useMessages();
	return (
		<>
			<Seo title={unsubscribe.seoTitle} description={unsubscribe.seoDescription} path="/unsubscribe" noindex/>
			<Unsubscribe/>
		</>
	);
}
